/* AI INDEX PRO landing: scroll reveal + dashboard animation. No dependencies. */
(function () {
  if (typeof window === 'undefined') return;

  // Enable the hidden→reveal states only when JS is available.
  document.documentElement.classList.add('aip-js');

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  /* ---------- Scroll-Aufbau: Einzelbloecke + gestaffelte Gruppen ---------- */
  function initReveal() {
    var singles = Array.prototype.slice.call(document.querySelectorAll('.aip-reveal:not(.is-in)'));
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-aip-stagger]:not(.is-in)'));

    /* Kaskaden-Index auf die direkten Kinder jeder Gruppe */
    groups.forEach(function (g) {
      for (var i = 0; i < g.children.length; i++) {
        g.children[i].style.setProperty('--aip-i', i);
      }
    });

    var targets = singles.concat(groups);
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = el.getAttribute('data-aip-delay') || 0;
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Dashboard animation (hero card) ---------- */

  // Counts "7.095", "14.997 €", "891", "100" up from 0, keeping separators & suffix.
  function animateCount(el, duration, delay) {
    var m = (el.textContent || '').match(/^(\D*?)([\d.]+)(.*)$/);
    if (!m) return;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var target = parseInt(numStr.replace(/\./g, ''), 10);
    if (isNaN(target)) return;
    var sep = numStr.indexOf('.') > -1;
    var fmt = function (n) { return sep ? n.toLocaleString('de-DE') : String(n); };
    el.textContent = prefix + fmt(0) + suffix;
    setTimeout(function () {
      var start = null;
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var e = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
        el.textContent = prefix + fmt(Math.round(target * e)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }, delay || 0);
  }

  function runDashAnim(card) {
    if (card.dataset.aipAnimated) return;
    card.dataset.aipAnimated = '1';
    if (REDUCE) return; /* reduced motion: keep final values, no movement */

    /* Score ring: read target BEFORE the counter rewrites the text. */
    var scoreEl = card.querySelector('.aip-score__txt strong');
    var score = scoreEl ? (parseInt((scoreEl.textContent || '').replace(/\D/g, ''), 10) || 0) : 0;
    var prog = card.querySelector('.aip-score__prog');
    if (prog) {
      var C = 326.7; /* 2πr, r=52 */
      prog.style.transition = 'none';
      prog.style.strokeDashoffset = C + 'px';
      void prog.getBoundingClientRect();
      requestAnimationFrame(function () {
        prog.style.transition = 'stroke-dashoffset 1.5s ' + EASE + ' .15s';
        prog.style.strokeDashoffset = (C * (1 - score / 100)) + 'px';
      });
    }

    /* Number count-ups (score, traffic, revenue, platform values) */
    var counts = card.querySelectorAll('[data-aip-count]');
    for (var i = 0; i < counts.length; i++) {
      animateCount(counts[i], 1400, 150 + i * 100);
    }

    /* Platform bars fill from 0, staggered */
    var bars = card.querySelectorAll('.aip-plat__bar i');
    for (var j = 0; j < bars.length; j++) {
      (function (bar, idx) {
        var w = bar.style.width;
        bar.style.transition = 'none';
        bar.style.width = '0%';
        void bar.getBoundingClientRect();
        requestAnimationFrame(function () {
          bar.style.transition = 'width 1.1s ' + EASE + ' ' + (250 + idx * 130) + 'ms';
          bar.style.width = w;
        });
      })(bars[j], j);
    }
  }

  function initDash() {
    var card = document.querySelector('.aip-hero__card');
    if (!card || card.dataset.aipAnimated) return;
    if (!('IntersectionObserver' in window)) { card.dataset.aipAnimated = '1'; return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { io.disconnect(); runDashAnim(card); }
      });
    }, { threshold: 0.35 });
    io.observe(card);
  }

  function boot() { initReveal(); initDash(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-run when Shopify theme editor injects/reloads sections
  document.addEventListener('shopify:section:load', boot);
})();
